import { selectTotalArea } from '../../../../selectors';

const makeSelectTotalArea = (): typeof selectTotalArea => selectTotalArea;

export { makeSelectTotalArea };
